export const forBusiness_beauty_challenges = [
	{
		icon: '🔹',
		subtitle: 'challengesData_subtitle1',
	},
	{
		icon: '🔹',
		subtitle: 'challengesData_subtitle2',
	},
	{
		icon: '🔹',
		subtitle: 'challengesData_subtitle3',
	},
	{
		icon: '🔹',
		subtitle: 'challengesData_subtitle4',
	},
];
